<template>
    <v-dialog v-model="isVisible" max-width="600">
		<p-card class="tw-p-none overflow-hidden">
			<p-header-dialog :negative-margin="false" @closeClicked="close()">
				Agregar Nuevo Item a {{ typeData.name }}
			</p-header-dialog>
			<section class="tw-flex tw-justify-end tw-items-center tw-gap-2 tw-p-4" v-if="typeData.code === 'PLTF'">
				<div class="wrapper-user-image">
					<div class="wrapper-user">
						<img
							:src="item.urlLogo !== null ? item.urlLogo : `${$imageUrl}/camera.svg`"
							alt="logo"
							height="100%"
							width="100%">
					</div>
					<div class="wrapper-camera">
						<load-file
							:show-input="false"
							:name-file="'imageLogo'"
							icon="camera_alt"
							color="white"
							:disabled="false"
							class-btn="circle-btn"
							:flag="false"
							@input="getImage">
						</load-file>
					</div>
				</div>
			</section>
			<section class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-p-4">
				<label :style="`color:${$appColors.info}; width: 100%;`">Nombre:
					<v-text-field
						label="Nombre"
						solo
						hide-details
						class="input-text"
						v-model="item.name"
					></v-text-field>
					<span
						v-if="$v.item.name.$invalid"
						class="message-error"
						:style="`color:${$appColors.error}`"
					>
						El Nombre es requerido
					</span>
				</label>
				<label :style="`color:${$appColors.info}; width: 100%;`">Código:
					<v-text-field
						label="Código"
						solo
						hide-details
						class="input-text"
						v-model="item.code"
					></v-text-field>
					<span
						v-if="$v.item.code.$invalid"
						class="message-error"
						:style="`color:${$appColors.error}`"
					>
						El Código es requerido
					</span>
				</label>
			</section>
			<section class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-p-4" v-if="typeData.code === 'PLTF'">
				<label :style="`color:${$appColors.info}; width: 100%;`">URL de la Plataforma:
					<v-text-field
						label="URL"
						solo
						hide-details
						class="input-text"
						v-model="item.urlPlatform"
					></v-text-field>
					<span
						v-if="$v.item.name.$invalid"
						class="message-error"
						:style="`color:${$appColors.error}`"
					>
						El URL es requerida
					</span>
				</label>
			</section>
			<p-horizontal-divider></p-horizontal-divider>
			<div class="tw-flex tw-justify-center tw-items-center tw-pb-4">
				<p-button
					:disabled="fieldsNone"
					type="primary"
					@click="saveNewItem"
					> Guardar
				</p-button>
			</div>
		</p-card>
	</v-dialog>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import CloseIcon from '@/modules/shared/components/icons/close-icon';
import PButton from '@/modules/shared/components/ui/p-button';
import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';
import loadFile from '@/components/shared/load-file-input';
import { required } from 'vuelidate/lib/validators';

export default {
	name: 'add-data-general-to-type-data-dialog',
	created() {
		if (this.typeData.code !== 'PLTF') {
			delete this.item.urlPlatform;
			delete this.item.urlLogo;
		}
	},
	data() {
		return {
			isVisible: false,
			item: {
				name: null,
				code: null,
				urlPlatform: null,
				urlLogo: null,
			},
		};
	},
	components: { PHeaderDialog, PButton, CloseIcon, PCard, PHorizontalDivider, loadFile },
	methods: {
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
			this.item = {
				name: null,
				code: null,
				urlPlatform: null,
				urlLogo: null,
			};
		},
		saveNewItem() {
			this.$emit('addNewItem', this.item);
			this.close();
		},
		getImage(url) {
			this.item.urlLogo = url;
		},
	},
	computed: {
		fieldsNone() {
			return !this.item.name || !this.item.code;
		},
	},
	props: ['typeData'],
	validations() {
		return {
			item: {
				name: { required },
				code: { required },
			},
		};
	},
};
</script>

<style lang="scss" scoped>
.wrapper-user-image {
	// width: 150px;
	max-height: 100px;
	position: relative;
}
.wrapper-camera {
	bottom: -15px;
	position: absolute;
	right: -5px;
}
.wrapper-user {
	border-radius: 0%;
	height: 70px;
	margin: auto;
	overflow: hidden;
	width: 150px;
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/general-data/add-data-general-to-type-data-dialog.vue